export const colors = {
  primaryGreen: "#21623e",
  backgroundGray: "#f5f5f5",
  mutedGray: "#75817d",
  lightGray: "#9b9c98",
  mediumGray: "#b2b7b4",
  darkGray: "#b2b7b4",
  borderGray: "#c1c2c0",
  textGray: "#4d4f59",
  success: "#5ED797",
  danger: "#DA2115",
  alarm: "#F66D44",
};
